import ACFBlock from "../../assets/js/blocks-settings/blocks";

/**
 * Custom footerView Block, describe your block here.
 */
class footerView {
	/**
	 * Constructor method
	 * 
	 * @param {HTMLElement} block 
	 */
	constructor(block) {
	}

	/**
	 * The name of your block, don't modify this static method!!
	 * 
	 * @return {string}
	 */
	static getName() {
		return "footer";
	}

	// Your methods
}

new ACFBlock(footerView);
    